module.exports = __webpack_public_path__ + "static/media/profile_banner_background.7e4b7ff3.png";